import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export const UrgentBanner = () => {
  return <div className="bg-amber-50 border border-amber-200 py-2 sm:py-3 px-3 sm:px-4 mb-4 sm:mb-6 rounded-md" data-id="element-235">
      <div className="flex items-center" data-id="element-236">
        <AlertCircleIcon className="text-red-600 h-4 sm:h-5 w-4 sm:w-5 mr-1 sm:mr-2 flex-shrink-0" data-id="element-237" />
        <p className="text-red-600 font-bold text-xs sm:text-sm" data-id="element-238">
          UPDATE: Sleep Strips Are Selling Out FAST! 50% OFF + FREE US Shipping
        </p>
      </div>
    </div>;
};